import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MaterialIcon from './MaterialIcon';
import { useAuth } from '../../context/AuthContext';

const NAV_LINKS = [
  { to: '/icerikler', label: 'İçerikler' },
  { to: '/privacy', label: 'Gizlilik' },
  { to: '/terms', label: 'Kullanım Koşulları' },
  { to: '/hesap-sil', label: 'Hesap Silme' },
] as const;

export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const closeMenu = () => setMenuOpen(false);

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <header className="celestial-nav">
      <div className="celestial-nav__inner">
        <Link to="/" className="celestial-nav__brand" onClick={closeMenu}>
          Astro Social
        </Link>

        <nav className="celestial-nav__links" aria-label="Ana menü">
          {NAV_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={isActive(to) ? 'active' : undefined}
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className="celestial-nav__actions">
          {user ? (
            <button
              type="button"
              className="celestial-btn-primary"
              onClick={() => navigate('/profil')}
            >
              Profil
            </button>
          ) : (
            <button
              type="button"
              className="celestial-btn-primary"
              onClick={() => navigate('/giris')}
            >
              Giriş Yap
            </button>
          )}
        </div>

        <button
          type="button"
          className="celestial-nav__menu-btn"
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <MaterialIcon name={menuOpen ? 'close' : 'menu'} size={28} />
        </button>
      </div>

      <nav
        className={`celestial-nav__drawer ${menuOpen ? 'open' : ''}`}
        aria-label="Mobil menü"
      >
        {NAV_LINKS.map(({ to, label }) => (
          <Link key={to} to={to} onClick={closeMenu}>
            {label}
          </Link>
        ))}
        {user ? (
          <Link to="/profil" onClick={closeMenu}>
            Profil
          </Link>
        ) : (
          <Link to="/giris" onClick={closeMenu}>
            Giriş Yap
          </Link>
        )}
      </nav>
    </header>
  );
}
